module.exports = __webpack_public_path__ + "static/media/bota-feminina.f4d4498f.jpg";